import _ from 'underscore';
import defaultOption from '@/model/chartOption.js';
import tool from '@/model/tool.js';


/**
 * 图表解析器代理类
 * @description:把图表类的接口数据转换为可以被echart渲染的option
 * @author:panshuwei
 * @date:2018-08-25
 *
 */
export default {

    baseBarbar(data, theme, direction = 'x', type = '') {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            xAxisData = _.has(obj, 'categories') ? obj.categories : [],
            legendData = [],
            series = [];

        let totalArr = [];
        if (_.has(arr[0], 'data')) {
            let len = arr[0].data.length;
            for (var i = 0; i < len; i++) {
                let temptotal = 0;
                _.each(arr, function(one) {
                    if (one.data[i] == undefined || one.data[i] !== one.data[i]) {
                        one.data[i] = 0
                    }
                    temptotal += parseFloat(one.data[i]);
                })
                totalArr.push(temptotal);
            }
        }

        var yAxisMax,
            maxData = 0;

        _.each(arr, (item, index) => {
            var legendItem = {
                name: item.name,
                icon: type,
            };

            legendData.push(legendItem);

            const showLabel = _.has(theme, 'showLabel') ? theme.showLabel : false;

            var seriesItem = {
                name: item.name,
                barWidth: _.has(theme, 'barWidth') ? theme.barWidth : defaultOption.SIZE.bar_width,
                barGap: _.has(theme, 'barGap') ? theme.barGap : defaultOption.SIZE.bar_gap,
                barMaxWidth: _.has(theme, 'barMaxWidth') ? theme.barMaxWidth : '20px',
                data: item.data,
                type: _.has(item, 'type') ? item.type : 'bar',
                stack: _.has(item, 'stack') ? item.stack : type,
                label: {
                    normal: {
                        show: showLabel,
                        position: 'insideBottomRight',
                        formatter: function(params) {
                            if (params.value == undefined || params.value !== params.value) {
                                params.value = 0;
                            }
                            if (totalArr[params.dataIndex] == 0) {
                                return ''
                            } else {
                                var percent = ((params.value / totalArr[params.dataIndex]) * 100).toFixed(2)
                                return percent + '%';
                            }
                        },
                        fontSize: 10,
                    }
                },
            };

            _.each(item.data, function(one) {
                if (one > maxData) {
                    maxData = one
                }
            })

            if (_.has(obj, 'warning')) {
                let markLineLabel = null;
                if (_.has(theme, 'markLineLabel')) {
                    markLineLabel = theme.markLineLabel;
                }
                let markLine = {
                    silent: true,
                    label: markLineLabel ? markLineLabel : {},
                    data: [{
                        yAxis: obj.warning
                    }]
                };

                if (obj.warning > maxData) {
                    yAxisMax = parseInt(obj.warning * 1.1);
                }

                if (_.has(theme, 'markLineStyles') && _.isArray(theme.markLineStyles)) {
                    const len = theme.markLineStyles.length;
                    markLine.lineStyle = theme.markLineStyles[index % len]
                }

                seriesItem.markLine = markLine;
            }

            series.push(seriesItem);
        });
        var totalItem = {
            name: '总计',
            type: 'bar',
            stack: type,
            markLine: {
                data: [{
                        type: 'max',
                        name: '最大值'
                    },
                    {
                        type: 'min',
                        name: '最小值'
                    },
                ],
                label: {
                    show: 'true',
                    position: 'start',
                },
                lineStyle: {
                    color: 'rgba(255, 81, 71, 0.85)'
                }
            },
            itemStyle: {
                normal: {
                    color: 'rgba(128, 128, 128, 0)'
                }
            },
            data: totalArr
        };

        var showTotal = false;
        if (_.has(theme, 'showTotal')) {
            showTotal = theme.showTotal;
        }
        // if (_.has(theme, 'yAxisMax')) {
        //   yAxisMax = theme.yAxisMax;
        // }

        if (showTotal) {
            series.push(totalItem);
        }

        const yAxisFormat = _.has(theme, 'yAxisFormat') ? theme.yAxisFormat : '{value}';

        const grid = _.has(theme, 'grid') ? this.extend(defaultOption.SIZE.grid, theme.grid) : defaultOption.SIZE.grid;

        const colors = _.has(theme, 'colors') ? theme.colors : []

        const legend = {
            // left: defaultOption.SIZE.legend.left,
            // top: 0,
            right: defaultOption.SIZE.legend.right,
            itemWidth: defaultOption.SIZE.itemWidth,
            itemHeight: defaultOption.SIZE.itemHeight,
            data: legendData,
            itemGap: defaultOption.SIZE.itemGap,
        }

        let axisLabel = {
            show: true,
            textStyle: {
                color: 'rgba(0,0,0,0.65)',
            }
        };
        if (theme.axisLabel) {
            axisLabel = {...axisLabel, ...theme.axisLabel }
        }

        _.extend(legend, theme.legend || {});

        let opt;
        // bar
        if (direction == 'y') {
            opt = {
                iTitle: title,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title: {
                    show: true,
                    text: ztitle,
                },
                grid,
                legend: {
                    // left: defaultOption.SIZE.legend.left,
                    // top: 25,
                    itemWidth: defaultOption.SIZE.itemWidth,
                    itemHeight: defaultOption.SIZE.itemHeight,
                    data: legendData,
                },
                yAxis: [{
                    type: 'category',
                    max: 100,
                    data: xAxisData,
                    nameGap: defaultOption.SIZE.nameGap,
                    boundaryGap: defaultOption.SIZE.boundaryGap,
                    axisTick: {
                        alignWithLabel: true,
                    },
                }],
                xAxis: [{
                    type: 'value',
                }],
                series,
            };
        } else {
            opt = {
                iTitle: title,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                color: colors,
                title: {
                    show: true,
                    text: ztitle,
                    top: -1,
                    left: -5,
                },
                grid,
                legend,
                xAxis: [{
                    type: 'category',
                    data: xAxisData,
                    nameGap: defaultOption.SIZE.nameGap,
                    boundaryGap: defaultOption.SIZE.boundaryGap,
                    axisTick: {
                        alignWithLabel: true,
                    },
                    axisLabel,
                }],
                yAxis: [{
                    type: 'value',
                    max: yAxisMax ? yAxisMax : null,
                    axisLabel: {
                        formatter: yAxisFormat,
                    },
                    minInterval: _.has(theme, 'minInterval') ? theme.minInterval : 0
                }],
                series,
            };
        }

        return opt;
    },

    bigScreenbar(data, theme) {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            xAxisData = _.has(obj, 'categories') ? obj.categories : [],
            legendData = [],
            series = [];

        _.each(arr, (item, index) => {
            var legendItem = {
                name: item.name,
                icon: 'stack',
            };

            legendData.push(legendItem);

            var seriesItem = {
                name: item.name,
                barWidth: _.has(theme, 'barWidth') ? theme.barWidth : defaultOption.SIZE.bar_width,
                barGap: '20%',
                barMaxWidth: _.has(theme, 'barMaxWidth') ? theme.barMaxWidth : '20px',
                data: item.data,
                type: 'bar'
            };

            series.push(seriesItem);
        });

        const grid = _.has(theme, 'grid') ? this.extend(defaultOption.SIZE.grid, theme.grid) : defaultOption.SIZE.grid;

        const colors = _.has(theme, 'colors') ? theme.colors : []

        const legend = {
            right: defaultOption.SIZE.legend.right,
            itemWidth: defaultOption.SIZE.itemWidth,
            itemHeight: defaultOption.SIZE.itemHeight,
            data: legendData,
            itemGap: defaultOption.SIZE.itemGap,
        }

        _.extend(legend, theme.legend || {});

        let opt;
        // bar
            opt = {
                iTitle: title,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                color: colors,
                title: {
                    show: true,
                    text: ztitle,
                    top: -1,
                    left: -5,
                },
                grid,
                legend,
                xAxis: [{
                    type: 'category',
                    data: xAxisData,
                    nameGap: defaultOption.SIZE.nameGap,
                    boundaryGap: defaultOption.SIZE.boundaryGap,
                    axisTick: {
                        alignWithLabel: true,
                    },
                }],
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        formatter:'{value}',
                    },
                    minInterval: _.has(theme, 'minInterval') ? theme.minInterval : 0
                }],
                series,
            };

        return opt;
    },

    // bar
    bar(data, theme) {
        return this.baseBarbar(data, theme);
    },

    // 横向bar
    hbar(data, theme) {
        return this.baseBarbar(data, theme, 'y');
    },

    // 堆叠bar
    mbar(data, theme) {
        return this.baseBarbar(data, theme, 'x', 'stack');
    },

    // 横向堆叠bar
    hmbar(data, theme) {
        return this.baseBarbar(data, theme, 'y', 'stack');
    },

    specialbar(data) {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            xAxisData = _.has(obj, 'categories') ? obj.categories : [],
            series = [],
            seriesData = [],
            barcolor = [];

        _.each(arr, (item, index) => {

            _.each(item.data, function(one) {

                if (one > 0 && one <= 50) {
                    barcolor = ["rgb(0,228,0)"];
                } else if (one > 50 && one <= 100) {
                    barcolor = ["rgb(255,255,0)"];
                } else if (one > 100 && one <= 150) {
                    barcolor = ["rgb(255,126,0)"];
                } else if (one > 150 && one <= 200) {
                    barcolor = ["rgb(255,0,0)"];
                } else if (one > 200 && one <= 300) {
                    barcolor = ["rgb(153,0,76)"];
                } else if (one > 300 && one <= 500) {
                    barcolor = ["rgb(126,0,35)"];
                } else if (one > 500) {
                    barcolor = ["#000000"];
                } else {
                    barcolor = ["#C7CACC"];
                }

                var itemData = {
                    value: one,
                    itemStyle: {
                        color: barcolor
                    }
                };

                seriesData.push(itemData);
            })

            var seriesItem = {
                name: item.name,
                barWidth: 10,
                barGap: defaultOption.SIZE.bar_gap,
                data: seriesData,
                type: _.has(item, 'type') ? item.type : 'bar',
            };

            series.push(seriesItem);

            var LineseriesItem = {
                name: item.name,
                connectNulls: false,
                data: seriesData,
                type: 'line',
            };

            series.push(LineseriesItem);
        });

        const grid = defaultOption.SIZE.grid;

        let opt;
        // bar
        opt = {
            tooltip: {
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                },
            },
            color: [],
            grid,
            xAxis: [{
                type: 'category',
                data: xAxisData,
                nameGap: defaultOption.SIZE.nameGap,
                boundaryGap: defaultOption.SIZE.boundaryGap,
                axisTick: {
                    alignWithLabel: true,
                },
            }],
            yAxis: [{
                type: 'value',
            }],
            series,
        };

        return opt;
    },

    line(data, theme = {}) {
        if (data == null) {
            throw new Error('no data');
        }
        let obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') && obj.yzTitle ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            categories = _.has(obj, 'categories') ? obj.categories : [],
            legendData = [],
            seriesData = [];

        let lineStyles = _.has(theme, 'lineStyles') ? theme.lineStyles : [];

        let totalArr = [];
        if (_.has(arr[0], 'data')) {
            let len = arr[0].data.length;
            for (var i = 0; i < len; i++) {
                let temptotal = 0;
                _.each(arr, function(one) {
                    if (one.data[i] === undefined || one.data[i] !== one.data[i]) {
                        one.data[i] = 0
                    }
                    temptotal += parseFloat(one.data[i]);
                })
                totalArr.push(temptotal);
            }
        }

        _.each(arr, (item, index) => {

            legendData.push({
                name: item.name,
                icon: _.has(theme, 'icon') ? theme.icon : 'stack',
            });

            let smooth = _.has(theme, 'smooth') ? theme.smooth : true;

            let seriesItem;

            if (lineStyles.length > 0) {
                seriesItem = {
                    name: item.name,
                    type: 'line',
                    connectNulls: false,
                    data: item.data,
                    smooth: smooth,
                    lineStyle: lineStyles[index],
                    markPoint: {
                        data: [],
                    },
                    markLine: {
                        data: [],
                        label: {
                            show: 'true',
                            position: 'start',
                        },
                    },
                };
            } else {
                seriesItem = {
                    name: item.name,
                    type: 'line',
                    connectNulls: false,
                    data: item.data,
                    smooth: smooth,
                    markPoint: {},
                    markLine: {
                        data: [],
                        label: {
                            show: 'true',
                            position: 'start',
                        },
                    },
                };
            }

            if (_.has(theme, 'markPoint')) {
                seriesItem.markPoint = this.extend(theme.markPoint);
            }
            if (_.has(theme, 'markLine')) {
                seriesItem.markLine = this.extend(theme.markLine);
            }
            if (_.has(item, 'itemStyle')) {
                seriesItem.itemStyle = item.itemStyle;
            }

            if (_.has(theme, 'areaStyle')) {
                seriesItem.areaStyle = {
                    normal: {
                        color: theme.areaStyle[index],
                    },
                };
            }

            seriesData.push(seriesItem);
        });

        if (theme && theme.seriesData) {
            seriesData = this.extend(seriesData, theme.seriesData);
        }

        var totalItem = {
            name: '总计',
            type: 'line',
            itemStyle: {
                normal: {
                    color: 'rgba(128, 128, 128, 0)'
                }
            },
            data: totalArr
        };

        var showTotal = false;
        if (_.has(theme, 'showTotal')) {
            showTotal = theme.showTotal;
        }

        if (showTotal) {
            seriesData.push(totalItem);
        }

        const grid = _.has(theme, 'grid') ? this.extend(defaultOption.SIZE.grid, theme.grid) : defaultOption.SIZE.grid;
        const legend = _.has(theme, 'legend') ? this.extend(defaultOption.SIZE.legend, theme.legend) : defaultOption.SIZE.legend;
        const flegend = this.extend(legend, {
            data: legendData
        });
        const yAxisFormat = _.has(theme, 'yAxisFormat') ? theme.yAxisFormat : '{value}';

        let tooltip = {
            trigger: 'axis',
        };

        if (_.has(theme, 'tooltip')) {
            tooltip = theme.tooltip;
        }

        let interval = null,
            rotate = null;
        if (_.has(theme, 'interval')) {
            interval = theme.interval;
        }
        if (_.has(theme, 'rotate')) {
            rotate = theme.rotate;
        }

        let dataZoom = null;
        if (_.has(theme, 'dataZoom')) {
            dataZoom = theme.dataZoom;
        }
        const boundaryGap = _.has(theme, 'boundaryGap') ? theme.boundaryGap : false;
        const themeyAxis = _.has(theme, 'yAxis') ? theme.yAxis : {};
        const colors = _.has(theme, 'colors') ? theme.colors : [];
        // line
        const opt = {
            iTitle: title,
            title: {
                show: true,
                text: ztitle,
                top: -1,
                left: -5,
            },
            grid,
            tooltip,
            color: colors,
            dataZoom: dataZoom,
            legend: flegend,
            toolbox: {
                show: false,
                feature: {
                    mark: {
                        show: true,
                    },
                    dataView: {
                        show: true,
                        readOnly: false,
                    },
                    magicType: {
                        show: true,
                        type: ['line', 'bar', 'stack', 'tiled'],
                    },
                    restore: {
                        show: true,
                    },
                    saveAsImage: {
                        show: true,
                    },
                },
            },
            calculable: true,
            xAxis: [{
                type: 'category',
                boundaryGap: boundaryGap,
                axisLabel: {
                    interval,
                    rotate
                },
                data: categories,
            }],
            yAxis: [{
                type: 'value',
                axisLabel: {
                    formatter: yAxisFormat,
                },
                ...themeyAxis,
                min: 'dataMin'
            }],
            series: seriesData,
        };
        return opt;
    },

    barLine(data, theme = {
        names: ['', '']
    }) {
        return this.doubleTypes(data, theme, {
            type_one: 'bar',
            type_two: 'line'
        });
    },

    lineBar(data, theme = {
        names: ['', '']
    }) {
        return this.doubleTypes(data, theme, {
            type_one: 'line',
            type_two: 'bar'
        });
    },

    lineLine(data, theme = {
        names: ['', '']
    }) {
        return this.doubleTypes(data, theme, {
            type_one: 'line',
            type_two: 'line'
        });
    },

    barBar(data, theme = {
        names: ['', '']
    }) {
        return this.doubleTypes(data, theme, {
            type_one: 'bar',
            type_two: 'bar'
        });
    },

    doubleTypes(data, theme = {}, axis = {
        type_one: 'bar',
        type_two: 'line'
    }) {

        if (data == null) {
            throw new Error('no data');
        }
        let mainArr = this.compatibleMultChartData(data),
            mainArrLen = mainArr.length,
            mainTitles = [],
            xAxisArr = [],
            yAxisArr = [],
            chartTitle = '',
            mainSeries = [],
            gridArr = [],
            dataZooms = [],
            legendData = [],
            dataZoomsIndexs = [];

        _.each(mainArr, (obj, mainIndex) => {
            let arr = this.compatibleSeries(obj),
                ztitle = _.has(obj, 'yzTitle') && obj.yzTitle ? obj.yzTitle : '',
                categories = _.has(obj, 'categories') ? obj.categories : [],
                seriesData = [];

            chartTitle = _.has(obj, 'title') ? obj.title : '';

            _.each(arr, (item, index) => {
                legendData.push({
                    name: item.name,
                    icon: _.has(theme, 'icon') ? theme.icon : 'stack',
                });

                const _type = (_.has(item, 'type') && item.type == 'axis_right') ? axis.type_two : axis.type_one;

                const seriesItem = {
                    name: item.name,
                    type: _type,
                    connectNulls: false,
                    data: item.data,
                    barWidth: _.has(theme, 'barWidth') ? theme.barWidth : defaultOption.SIZE.bar_width,
                    barMaxWidth: _.has(theme, 'barMaxWidth') ? theme.barMaxWidth : '20px',
                    xAxisIndex: mainIndex,
                    yAxisIndex: mainIndex,
                };

                if (_.has(item, 'itemStyle')) {
                    seriesItem.itemStyle = item.itemStyle;
                }

                if (_.has(obj, 'markLine')) {
                    seriesItem.markLine = obj.markLine;
                }

                if (_.has(obj, 'warning')) {
                    let markLine = {
                        silent: true,
                        data: [{
                            yAxis: obj.warning
                        }]
                    };

                    if (_.has(theme, 'markLineStyles') && _.isArray(theme.markLineStyles)) {
                        const len = theme.markLineStyles.length;
                        markLine.lineStyle = theme.markLineStyles[mainIndex % len]
                    }

                    seriesItem.markLine = markLine;
                }

                if (_.has(theme, 'areaStyle')) {
                    seriesItem.areaStyle = {
                        normal: {
                            color: theme.areaStyle[index],
                        },
                    };
                }

                if (_.has(obj, 'markArea')) {
                    seriesItem.markArea = {
                        data: obj.markArea,
                        label: {
                            color: '#47C85C'
                        },
                        itemStyle: {
                            color: 'rgba(255,81,71,0.2)'
                        }
                    };
                }

                seriesData.push(seriesItem);
                mainSeries.push(seriesItem);
            });

            if (theme && theme.seriesData) {
                seriesData = this.extend(seriesData, theme.seriesData);
            }

            const r_yAxisFormat = _.has(theme, 'yAxisFormat') ? theme.yAxisFormat : '{value}';
            const boundaryGap = _.has(theme, 'boundaryGap') ? theme.boundaryGap : defaultOption.SIZE.boundaryGap;

            let grid = _.has(theme, 'mGrid') ? this.extend(defaultOption.SIZE.mGrid, theme.mGrid) : defaultOption.SIZE.mGrid;

            // grid.top = ((mainIndex * 100 / mainArrLen) + 10) + '%';
            grid.bottom = ((mainArrLen - mainIndex - 1) * 100 / mainArrLen) + '%';

            let newGrid = _.clone(grid);

            gridArr.push(newGrid);

            let interval = null;
            if (_.has(theme, 'interval')) {
                interval = theme.interval;
            }

            let alignWithLabel = null;
            if (_.has(theme, 'alignWithLabel')) {
                alignWithLabel = theme.alignWithLabel;
            }

            dataZoomsIndexs.push(mainIndex);

            if (_.has(theme, 'dataZoom') && theme.dataZoom) {
                dataZooms = [{
                    type: 'inside',
                    start: 0,
                    end: 100,
                    xAxisIndex: dataZoomsIndexs
                }, {
                    start: 0,
                    end: 10,
                    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    }
                }]
            }

            mainTitles.push({
                show: true,
                text: ztitle,
                top: -1,
                left: -5,
            });

            xAxisArr.push({
                type: 'category',
                boundaryGap: boundaryGap,
                axisTick: {
                    alignWithLabel
                },
                axisLabel: {
                    interval,
                },
                data: categories,
                gridIndex: mainIndex
            });

            yAxisArr.push({
                type: 'value',
                axisLabel: {
                    formatter: r_yAxisFormat,
                },
                gridIndex: mainIndex,
                min: 'dataMin'
            });
        });

        const legend = _.has(theme, 'legend') ? this.extend(defaultOption.SIZE.legend, theme.legend, {
            data: legendData
        }) : defaultOption.SIZE.legend;

        let tooltip = {
            trigger: 'axis',
        };

        if (_.has(theme, 'tooltip')) {
            tooltip = theme.tooltip;
        }

        const opt = {
            iTitle: chartTitle,
            title: mainTitles,
            grid: gridArr,
            tooltip,
            dataZoom: dataZooms,
            legend: legend,
            toolbox: {
                show: false,
                feature: {
                    mark: {
                        show: true,
                    },
                    dataView: {
                        show: true,
                        readOnly: false,
                    },
                    magicType: {
                        show: true,
                        type: ['line', 'bar', 'stack', 'tiled'],
                    },
                    restore: {
                        show: true,
                    },
                    saveAsImage: {
                        show: true,
                    },
                },
            },
            calculable: true,
            xAxis: xAxisArr,
            yAxis: yAxisArr,
            series: mainSeries,
        };

        return opt;
    },

    doubleAxis(data, theme = {}, axis = {
        axis_left: {
            name: '产值',
            type: 'line'
        },
        axis_right: {
            name: '增速',
            type: 'line'
        }
    }) {
        if (data == null) {
            throw new Error('no data');
        }
        let obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') && obj.yzTitle ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            categories = _.has(obj, 'categories') ? obj.categories : [],
            legendData = [],
            seriesData = [];

        _.each(arr, (item, index) => {
            legendData.push({
                name: item.name,
                icon: _.has(theme, 'icon') ? theme.icon : 'stack',
            });

            const _type = (_.has(item, 'type') && item.type == 'axis_right') ? axis.axis_right.type : axis.axis_left.type;
            const yAxisIndex = (_.has(item, 'type') && item.type == 'axis_right') ? 1 : 0;

            const seriesItem = {
                name: item.name,
                type: _type,
                yAxisIndex,
                connectNulls: false,
                data: item.data,
                barWidth: _.has(theme, 'barWidth') ? theme.barWidth : defaultOption.SIZE.bar_width,
                barMaxWidth: _.has(theme, 'barMaxWidth') ? theme.barMaxWidth : '20px',
            };

            if (yAxisIndex == 1) {
                seriesItem.lineStyle = {
                    normal: {
                        width: 2,
                        type: 'solid',
                    },
                };
            }

            if (_.has(item, 'itemStyle')) {
                seriesItem.itemStyle = item.itemStyle;
            }

            if (_.has(theme, 'areaStyle')) {
                seriesItem.areaStyle = {
                    normal: {
                        color: theme.areaStyle[index],
                    },
                };
            }
            seriesData.push(seriesItem);
        });

        if (theme && theme.seriesData) {
            seriesData = this.extend(seriesData, theme.seriesData);
        }

        const grid = _.has(theme, 'grid') ? this.extend(defaultOption.SIZE.grid, theme.grid) : defaultOption.SIZE.grid;
        const legend = _.has(theme, 'legend') ? this.extend(defaultOption.SIZE.legend, theme.legend) : defaultOption.SIZE.legend;
        const flegend = this.extend(legend, {
            data: legendData
        });

        const r_yAxisFormat = _.has(theme, 'yAxisFormat') ? theme.yAxisFormat : '{value}%';
        const boundaryGap = _.has(theme, 'boundaryGap') ? theme.boundaryGap : false;


        let tooltip = {
            trigger: 'axis',
        };

        if (_.has(theme, 'tooltip')) {
            tooltip = theme.tooltip;
        }

        let interval = null;
        if (_.has(theme, 'interval')) {
            interval = theme.interval;
        }

        // line
        const opt = {
            iTitle: title,
            title: {
                show: true,
                text: ztitle,
                top: -1,
                left: -5,
            },
            grid,
            tooltip,
            legend: flegend,
            toolbox: {
                show: false,
                feature: {
                    mark: {
                        show: true,
                    },
                    dataView: {
                        show: true,
                        readOnly: false,
                    },
                    magicType: {
                        show: true,
                        type: ['line', 'bar', 'stack', 'tiled'],
                    },
                    restore: {
                        show: true,
                    },
                    saveAsImage: {
                        show: true,
                    },
                },
            },
            calculable: true,
            xAxis: [{
                type: 'category',
                boundaryGap: boundaryGap,
                axisLabel: {
                    interval,
                },
                data: categories,
            }],
            yAxis: [{
                type: 'value',
                name: axis.axis_left.name,
                axisLabel: {
                    formatter: '{value}',
                },
            }, {
                type: 'value',
                name: axis.axis_right.name,
                axisLabel: {
                    formatter: r_yAxisFormat,
                },
            }],
            series: seriesData,
        };

        return opt;
    },

    line_line(data, theme = {
        names: ['', '']
    }) {
        return this.doubleAxis(data, theme, {
            axis_left: {
                name: theme.names[0],
                type: 'line'
            },
            axis_right: {
                name: theme.names[1],
                type: 'line'
            }
        });
    },

    bar_bar(data, theme = {
        names: ['', '']
    }) {
        return this.doubleAxis(data, theme, {
            axis_left: {
                name: theme.names[0],
                type: 'bar'
            },
            axis_right: {
                name: theme.names[1],
                type: 'bar'
            }
        });
    },

    line_bar(data, theme = {
        names: ['', '']
    }) {
        return this.doubleAxis(data, theme, {
            axis_left: {
                name: theme.names[0],
                type: 'line'
            },
            axis_right: {
                name: theme.names[1],
                type: 'bar'
            }
        });
    },

    circle(data, theme = {
        legend: {
            showPercent: false,
            show: true
        }
    }, type = 'pie') {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            dataField = _.has(arr[0], 'value') ? 'value' : 'data',
            total = tool.getTotal(arr, dataField),
            legendData = [],
            seriesData = [];

        let hoverAnimation = _.has(theme, 'hoverAnimation') ? theme.hoverAnimation : true;

        _.each(arr, (item) => {
            var legendItem = {
                name: (theme.legend && theme.legend.showPercent == false) ? item.name : item.name + '：' + tool.getAccuratePercent(arr, dataField, item),
                icon: 'circle',
            };

            legendData.push(legendItem);

            if (item.value == 0) {
                hoverAnimation = false;
                var seriesItem = {
                    name: (theme.legend && theme.legend.showPercent == false) ? item.name : item.name + '：' + tool.getAccuratePercent(arr, dataField, item),
                    value: item.value,
                    itemStyle: {
                        color: '#d0d0d0'
                    }
                };
                seriesData.push(seriesItem);
            } else {
                var seriesItem = {
                    name: (theme.legend && theme.legend.showPercent == false) ? item.name : item.name + '：' + tool.getAccuratePercent(arr, dataField, item),
                    value: item.value,
                };
                seriesData.push(seriesItem);
            }

        });

        var showLabel = false;
        if (_.has(theme, 'showLabel')) {
            showLabel = theme.showLabel;
        }

        var itemStyle = {};
        if (_.has(theme, 'itemStyle')) {
            itemStyle = theme.itemStyle;
        }
        var newtitle,
            title = {
                text: ztitle,
                subtext: total,
                x: 'center',
                y: '45%',
                show: true,
            };

        var default_radius = type == 'pie' ? ['0%', '60%'] : ['60%', '78%'];

        var center = ['20%', '50%'],
            radius = default_radius;

        var legend = {
            show: false,
            type: 'scroll',
            orient: 'vertical',
            x: '50%',
            y: 'center',
            itemWidth: 6,
            itemHeight: 6,
            data: legendData,
            itemGap: defaultOption.SIZE.roseItemGap, // 20,
            fontSize: 14,
        };

        var labelFormatter = (theme.label && theme.label.showPercent == true) ? '{b}: {d}%' : '{b} ({c}) ';

        var label = { // 饼图图形上的文本标签
            normal: {
                show: showLabel,
                position: 'outside', // 标签的位置
                formatter: labelFormatter,
            },
        };

        if (_.has(theme, 'title')) {
            newtitle = this.extend(title, theme.title);
            if (_.has(theme.title, 'subRichTitle')) {
                newtitle.subtext = newtitle.subtext + newtitle.subRichTitle;
            }
        }

        if (_.has(theme, 'radius')) {
            radius = theme.radius;
        }

        if (_.has(theme, 'legend')) {
            legend = this.extend(legend, theme.legend);
        }

        if (_.has(theme, 'center')) {
            center = theme.center;
        }

        const silent = _.has(theme, 'silent') ? theme.silent : false;

        // circle
        const opt = {
            iTitle: title,
            tooltip: {
                trigger: 'item',
                formatter: labelFormatter,
                show: theme.tooltip ? theme.tooltip.show : true,
            },
            title: newtitle,
            legend,
            toolbox: {
                show: false,
                feature: {
                    mark: {
                        show: true,
                    },
                    dataView: {
                        show: true,
                        readOnly: false,
                    },
                    magicType: {
                        show: true,
                        type: ['pie', 'funnel'],
                        option: {
                            funnel: {
                                x: '25%',
                                width: '50%',
                                funnelAlign: 'center',
                                max: 1548,
                            },
                        },
                    },
                    restore: {
                        show: true,
                    },
                    saveAsImage: {
                        show: true,
                    },
                },
            },
            calculable: true,
            series: [{
                name: title,
                type: 'pie',
                hoverAnimation: hoverAnimation,
                silent: silent,
                radius,
                center,
                label,
                itemStyle: this.extend({
                    normal: {
                        color: function(params) {
                            // build a color map as your need.
                            var colorList = theme.colorList ? theme.colorList : ['#006095','#d0d0d0','#FFB700','#008CAB'];

                            return colorList[params.dataIndex]
                        },
                        borderWidth: 2,
                        borderColor: '#fff',
                        label: {
                            show: showLabel,
                        },
                        labelLine: {
                            show: showLabel,
                        },
                    },
                    emphasis: {
                        label: {
                            show: showLabel,
                            position: 'center',
                            textStyle: {
                                fontSize: '12',
                                fontWeight: 'bold',
                            },
                        },
                    },
                }, itemStyle),
                data: seriesData,
            }],
        };

        return opt;
    },

    pie(data, theme = {
        legend: {
            showPercent: false,
            show: true
        }
    }) {
        return this.circle(data, theme, 'pie');
    },

    ring(data, theme = {
        legend: {
            showPercent: false,
            show: true
        }
    }) {
        return this.circle(data, theme, 'ring');
    },

    bigScreenRing1(data, theme) {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            dataField = _.has(arr[0], 'value') ? 'value' : 'data',
            total = tool.getTotal(arr, dataField),
            percent = 0,
            legendData = [],
            seriesData = [];

            if(total == 0) {
                percent = 0;
            } else if (arr[1].value == total) {
                percent = 100;
            } else {
                percent = ((arr[1].value/total)*100).toFixed(2);
            }

        let hoverAnimation = _.has(theme, 'hoverAnimation') ? theme.hoverAnimation : true;
        _.each(arr, (item) => {
            var legendItem = {
                name:item.name,
                icon: 'stack',
            };

            legendData.push(legendItem);

            if (item.value == 0) {
                hoverAnimation = false;
                var seriesItem = {
                    name: item.name,
                    value: item.value,
                    itemStyle: {
                        color: '#d0d0d0'
                    }
                };
                seriesData.push(seriesItem);
            } else {
                var seriesItem = {
                    name: item.name,
                    value: item.value,
                };
                seriesData.push(seriesItem);
            }

        });

        var legend = {
            show: false,
            orient: 'vertical',
            x: '50%',
            y: 'center',
            itemWidth: 10,
            itemHeight: 10,
            data: legendData,
            itemGap: 15, 
            fontSize: 14
        };


        var showLabel = false;
        if (_.has(theme, 'showLabel')) {
            showLabel = theme.showLabel;
        }

        var itemStyle = {};
        if (_.has(theme, 'itemStyle')) {
            itemStyle = theme.itemStyle;
        }
        var newtitle = {
            text: [
                '{value|' + percent + '}',
                '{unit|%}',
            ].join(' '),
            rich: {
                value: {
                    color: '#ffffff',
                    fontSize: 24,
                    lineHeight: 40,
                },
                unit: {
                    color: '#ffffff',
                    lineHeight: 16
                },
            },
            top: 'center',
            left: '50%',
            textAlign: 'center',
            textStyle: {
                rich: {
                    value: {
                        color: '#ffffff',
                        fontSize: 24,
                        lineHeight: 40,
                    },
                    unit: {
                        color: '#ffffff',
                        lineHeight: 16
                    },
                },
            },
        };

        var default_radius = ['60%', '78%'];

        var center = ['20%', '50%'],
            radius = default_radius;

        var labelFormatter = (theme.label && theme.label.showPercent == true) ? '{b}: {d}%' : '{b} ({c}) ';

        var label = { // 饼图图形上的文本标签
            normal: {
                show: showLabel,
                position: 'center', // 标签的位置            
            },
        };

        if (_.has(theme, 'title')) {
            newtitle = this.extend(newtitle, theme.title);
        }

        if (_.has(theme, 'radius')) {
            radius = theme.radius;
        }

        if (_.has(theme, 'legend')) {
            legend = this.extend(legend, theme.legend);
        }

        if (_.has(theme, 'center')) {
            center = theme.center;
        }

        const silent = _.has(theme, 'silent') ? theme.silent : false;

        // circle
        const opt = {
            iTitle: title,
            tooltip: {
                trigger: 'item',
                formatter: labelFormatter,
                show: theme.tooltip ? theme.tooltip.show : true,
            },
            title: newtitle,
            legend,
            calculable: true,
            series: [{
                name: title,
                type: 'pie',
                hoverAnimation: hoverAnimation,
                silent: silent,
                radius,
                center,
                label,
                itemStyle: itemStyle,
                data: seriesData,
            }],
        };

        return opt;
    },

    bigScreenRing(data, theme) {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            dataField = _.has(arr[0], 'value') ? 'value' : 'data',
            total = tool.getTotal(arr, dataField),
            legendData = [],
            seriesData = [];

        let hoverAnimation = _.has(theme, 'hoverAnimation') ? theme.hoverAnimation : true;
        _.each(arr, (item) => {
            var legendItem = {
                name:item.name,
                icon: 'stack',
            };

            legendData.push(legendItem);

            if (item.value == 0) {
                hoverAnimation = false;
                var seriesItem = {
                    name: item.name,
                    value: item.value,
                    itemStyle: {
                        color: '#d0d0d0'
                    }
                };
                seriesData.push(seriesItem);
            } else {
                var seriesItem = {
                    name: item.name,
                    value: item.value,
                };
                seriesData.push(seriesItem);
            }

        });

        var legend = {
            show: false,
            orient: 'vertical',
            x: '50%',
            y: 'center',
            itemWidth: 10,
            itemHeight: 10,
            data: legendData,
            itemGap: 15, 
            fontSize: 14,
            formatter:(name)=>{
                var target,percent;
                for (var i = 0, l = arr.length; i < l; i++) {
                    if (arr[i].name == name) {
                        target = arr[i].value;
                    }
                }
                if(total==0) {
                    percent = 0;
                }else {
                    percent = ((target/total)*100).toFixed(2);
                }
                
                return name + ' | ' + percent + '%' +' | ' +target;
            }
        };


        var showLabel = false;
        if (_.has(theme, 'showLabel')) {
            showLabel = theme.showLabel;
        }

        var itemStyle = {};
        if (_.has(theme, 'itemStyle')) {
            itemStyle = theme.itemStyle;
        }
        var newtitle = {
            text: [
                '{value|' + total + '}',
                '{unit|家}',
            ].join(' '),
            rich: {
                value: {
                    color: '#ffffff',
                    fontSize: 36,
                    lineHeight: 40,
                },
                unit: {
                    color: '#ffffff',
                    lineHeight: 16
                },
            },
            top: 'center',
            left: '25%',
            textAlign: 'center',
            textStyle: {
                rich: {
                    value: {
                        color: '#ffffff',
                        fontSize: 36,
                        lineHeight: 40,
                    },
                    unit: {
                        color: '#ffffff',
                        lineHeight: 16
                    },
                },
            },
        };

        var default_radius = ['60%', '78%'];

        var center = ['20%', '50%'],
            radius = default_radius;

        var labelFormatter = (theme.label && theme.label.showPercent == true) ? '{b}: {d}%' : '{b} ({c}) ';

        var label = { // 饼图图形上的文本标签
            normal: {
                show: showLabel,
                position: 'center', // 标签的位置            
            },
        };

        if (_.has(theme, 'title')) {
            newtitle = this.extend(newtitle, theme.title);
        }

        if (_.has(theme, 'radius')) {
            radius = theme.radius;
        }

        if (_.has(theme, 'legend')) {
            legend = this.extend(legend, theme.legend);
        }

        if (_.has(theme, 'center')) {
            center = theme.center;
        }

        const silent = _.has(theme, 'silent') ? theme.silent : false;

        // circle
        const opt = {
            iTitle: title,
            tooltip: {
                trigger: 'item',
                formatter: labelFormatter,
                show: theme.tooltip ? theme.tooltip.show : true,
            },
            title: newtitle,
            legend,
            calculable: true,
            series: [{
                name: title,
                type: 'pie',
                hoverAnimation: hoverAnimation,
                silent: silent,
                radius,
                center,
                label,
                itemStyle: itemStyle,
                data: seriesData,
            }],
        };

        return opt;
    },

    rose(data, theme = {
        legend: {
            showPercent: false,
            show: true
        }
    }) {
        if (data == null) {
            throw new Error('no data');
        }

        var obj = this.compatibleData(data),
            arr = this.compatibleSeries(obj),
            dataField = _.has(arr[0], 'value') ? 'value' : 'data',
            total = tool.getTotal(arr, dataField),
            ztitle = _.has(obj, 'yzTitle') ? obj.yzTitle : '',
            title = _.has(obj, 'title') ? obj.title : '',
            legendData = [],
            seriesData = [];

        const sortData = arr.sort((a, b) => b.value - a.value);

        const slen = sortData.length;

        _.each(sortData, (item, index) => {
            var legendItem = {
                name: (theme.legend && theme.legend.showPercent == false) ? item.name : item.name + '  ' + tool.getPercent(total, item[dataField]),
                icon: 'circle',
            };

            legendData.push(legendItem);
            var seriesItem = {
                name: (theme.legend && theme.legend.showPercent == false) ? item.name : item.name + '  ' + tool.getPercent(total, item[dataField]),
                value: item.value,
            };

            if (_.has(theme, 'colors')) {
                seriesItem.itemStyle = {
                    normal: {
                        color: theme.colors[index % slen],
                    },
                };
            }

            seriesData.push(seriesItem);
        });

        var showLabel = true;
        var radius = ['30%', '80%'];
        var center = ['50%', '50%'];
        if (_.has(theme, 'showLabel')) {
            showLabel = theme.showLabel;
        }

        if (_.has(theme, 'radius')) {
            radius = theme.radius;
        }

        if (_.has(theme, 'center')) {
            center = theme.center;
        }
        var legend = {
            show: false,
            type: 'scroll',
            orient: 'vertical',
            right: 50,
            top: 140,
            bottom: 20,
            itemWidth: defaultOption.SIZE.itemWidth,
            itemHeight: defaultOption.SIZE.itemHeight,
            data: legendData,
            itemGap: defaultOption.SIZE.roseItemGap, // 20
        };
        if (_.has(theme, 'legend')) {
            legend = this.extend(legend, theme.legend);
        }
        // rose
        const opt = {
            iTitle: title,
            title: {
                show: false,
                text: ztitle,
                left: -5,
                top: -1,
                textStyle: {
                    fontSize: defaultOption.SIZE.label_font_size,
                    fontWeight: 'normal',
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend,
            grid: this.extend({
                itemWidth: defaultOption.SIZE.itemWidth,
                itemHeight: defaultOption.SIZE.itemHeight,
            }, defaultOption.SIZE.grid),
            series: [{
                name: title,
                type: 'pie',
                radius,
                center,
                data: seriesData,
                roseType: 'radius',
                label: {
                    normal: {
                        show: showLabel,
                    },
                },
                labelLine: {
                    normal: {
                        show: showLabel,
                        smooth: 0.2,
                        length: 10,
                        length2: 20,
                    },
                },
                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay(idx) {
                    return Math.random() * 200;
                },
            }],
        };

        return opt;
    },

    complexRingPie(data, theme) {
        if (data == null) {
            throw new Error('no data');
        }
        var obj = this.compatibleData(data),
            seriesData1 = _.has(obj, 'seriesDataOuter') ? obj.seriesDataOuter : {},
            seriesData2 = _.has(obj, 'seriesDataInner') ? obj.seriesDataInner : {};

        const opt = {
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            series: [{
                    name: seriesData1 && _.has(seriesData1, 'title') ? seriesData1.title : '',
                    type: 'pie',
                    radius: ['60%', '78%'],
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    label: {
                        normal: {
                            show: false
                        }
                    },
                    data: seriesData1 && _.has(seriesData1, 'series') ? seriesData1.series : [],
                },
                {
                    name: seriesData2 && _.has(seriesData2, 'title') ? seriesData2.title : '',
                    type: 'pie',
                    selectedMode: 'single',
                    hoverOffset: 5,
                    radius: [0, '50%'],

                    label: {
                        normal: {
                            show: false
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    data: seriesData2 && _.has(seriesData2, 'series') ? seriesData2.series : [],
                }
            ]
        };

        return opt;
    },

    sankey(data, theme) {
        const opt = {
            tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove',
            },
            series: [{
                type: 'sankey',
                layout: 'none',
                title: {
                    // text: 'Sankey Diagram'
                },
                data: [{
                    name: '电',
                    itemStyle: {
                        normal: {
                            color: ['#3498DB'],
                        },
                    },
                }, {
                    name: '水',
                    itemStyle: {
                        normal: {
                            color: ['#1ABC9C'],
                        },
                    },
                }, {
                    name: '气',
                    itemStyle: {
                        normal: {
                            color: ['#9B59B6'],
                        },
                    },
                }, {
                    name: '热',
                    itemStyle: {
                        normal: {
                            color: ['#F1C40F'],
                        },
                    },
                }, {
                    name: '次级用能单位1',
                    itemStyle: {
                        normal: {
                            color: ['#2980B9'],
                        },
                    },
                }, {
                    name: '次级用能单位2',
                    itemStyle: {
                        normal: {
                            color: ['#2980B9'],
                        },
                    },
                }, {
                    name: '用能设备1',
                    itemStyle: {
                        normal: {
                            color: ['#16A085'],
                        },
                    },
                }, {
                    name: '用能设备2',
                    itemStyle: {
                        normal: {
                            color: ['#16A085'],
                        },
                    },
                }, {
                    name: '废能',
                    itemStyle: {
                        normal: {
                            color: ['#7F8C8D'],
                        },
                    },
                }, {
                    name: '有效能源',
                    itemStyle: {
                        normal: {
                            color: ['#27AE60'],
                        },
                    },
                }],
                lineStyle: {
                    normal: {
                        color: 'source',
                        curveness: 0.5,
                    },
                },
                links: [{
                    source: '电',
                    target: '次级用能单位1',
                    value: 5,
                }, {
                    source: '电',
                    target: '次级用能单位2',
                    value: 3,
                }, {
                    source: '电',
                    target: '用能设备2',
                    value: 8,
                }, {
                    source: '水',
                    target: '次级用能单位1',
                    value: 5,
                }, {
                    source: '水',
                    target: '次级用能单位2',
                    value: 3,
                }, {
                    source: '水',
                    target: '用能设备2',
                    value: 8,
                }, {
                    source: '气',
                    target: '用能设备2',
                    value: 8,
                }, {
                    source: '热',
                    target: '废能',
                    value: 8,
                }, {
                    source: '次级用能单位1',
                    target: '用能设备1',
                    value: 3,
                }, {
                    source: '次级用能单位1',
                    target: '用能设备2',
                    value: 3,
                }, {
                    source: '次级用能单位2',
                    target: '用能设备2',
                    value: 3,
                }, {
                    source: '用能设备1',
                    target: '废能',
                    value: 3,
                }, {
                    source: '用能设备2',
                    target: '有效能源',
                    value: 3,
                }],
            }],
        };

        return opt;
    },

    map(data, theme) {
        if (data == null) {
            throw new Error('no data');
        }

        var max = 0,
            pName = 'beijing';

        _.each(data, function(one) {
            max = max >= parseFloat(one.value) ? max : parseFloat(one.value);
        });

        if (_.has(theme, 'pName')) {
            pName = theme.pName;
        }
        const opt = {
            title: {
                show: false,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b}<br/>{c}',
            },
            visualMap: {
                min: 0,
                max: max,
                text: ['高', '低'],
                realtime: false,
                calculable: true,
                left: 'right',
                inRange: {
                    color: ['#d4f3e5', '#2bb86f'],
                },
            },
            series: [{
                name: '',
                type: 'map',
                mapType: pName, // 自定义扩展图表类型
                itemStyle: {
                    normal: {
                        label: {
                            show: false
                        },
                        borderColor: '#d7e6de',
                        borderWidth: 1,
                    },
                    emphasis: {
                        label: {
                            show: true
                        }
                    },
                },
                data,

            }, ],
        };

        return opt;
    },

    compatibleMultChartData(data) {
        let arr = [];

        if (_.has(data, 'chartData')) {
            if (_.isArray(data.chartData)) {
                arr = _.clone(data.chartData);
            } else if (_.isObject(data.chartData)) {
                arr.push(_.clone(data.chartData));
            }
        }

        return arr;
    },

    compatibleData(data) {
        var obj = {};

        if (_.has(data, 'chartData')) {
            if (_.isArray(data.chartData)) {
                obj = data.chartData[0];
            } else {
                obj = data.chartData;
            }
        }

        return obj;
    },

    compatibleSeries(data) {
        let result = [];

        if (_.has(data, 'seriesData')) {
            result = data.seriesData;
        } else if (_.has(data, 'series')) {
            result = data.series;
        } else {
            result = [];
        }
        return result;
    },

    extend(...args) {
        let result = {};

        _.each(args, function(obj) {
            _.extend(result, obj);
        });

        return result;
    }
};


// WEBPACK FOOTER //
// ./src/model/chartParser.js